import type { V2Event } from './rtcV2Machine';

export const RTC_V2_FLAG_KEY = 'hc_rtc_v2';
let directV2Disabled = false;

/** Только явный '0' выключает direct v2; отказ сервера помним до перезагрузки. */
export function rtcV2Enabled(): boolean {
  if (directV2Disabled) return false;
  try { return localStorage.getItem(RTC_V2_FLAG_KEY) !== '0'; }
  catch { return true; }
}

export function setRtcV2Enabled(on: boolean): void {
  try { localStorage.setItem(RTC_V2_FLAG_KEY, on ? '1' : '0'); }
  catch { /* хранилище недоступно */ }
}

/** Групповой протокол сохраняет прежнее явное включение. */
export function rtcGroupV2Enabled(): boolean {
  try { return localStorage.getItem(RTC_V2_FLAG_KEY) === '1'; }
  catch { return false; }
}

export function isDirectV2Disabled(event: V2Event): boolean {
  return event.v === 2 && event.callKind !== 'group' && event.callId == null && (
    (event.type === 'ended' && event.reason === 'forbidden' && event.detail === 'unsupported_peer') ||
    (event.type === 'call_rejected' && event.reason === 'v2_disabled')
  );
}

export function rememberDirectV2Disabled(): void { directV2Disabled = true; }
